export default "__VITE_ASSET__CuXloCUH__"